import { getDayFormat, fileUpload } from 'src/app/common/utils';
import { createBlob, getBlob } from 'src/app/common/network';
import { Dispatch } from 'react';

export const getError = (err: any) => {
  if (err.errors && Array.isArray(err.errors) && err.errors.length > 0) {
    if (err.errors[0].error) {
      return err.errors[0].error;
    }
    return err.errors[0];
  } else if (err.errors && err.errors.error) {
    return err.errors.error;
  } else {
    return err;
  }
};

export const formatDay = (value?: Date) => {
  if (!value) return undefined;
  return getDayFormat(value);
};

/**
 * Get blob details by resource IDs
 * @param resourceIds - The resource ID to fetch blob details
 * @param dispatch - Redux dispatch function
 * @returns Blob information with url, blobId, etc.
 */
export const fetchBlobDetails = async (resourceIds: string, dispatch?: Dispatch<any>) => {
  try {
    const blobDetail = await getBlob({ resourceIds }, dispatch);
    const result = blobDetail[0];
    if (result) {
      return result;
    } else {
      throw new Error('Unable to retrieve blob details');
    }
  } catch (err) {
    throw new Error(`Fetch blob details failed: ${err instanceof Error ? err.message : String(err)}`);
  }
};

/**
 * Upload a file to blob storage
 * @param file - The file to upload
 * @param onProgress - Callback function to track upload progress
 * @param dispatch - Redux dispatch function
 * @returns Blob ID from create blob response
 */
export const uploadFileToBlob = async (
  file: File,
  onProgress: (progress: number) => void,
  dispatch?: Dispatch<any>,
) => {
  try {
    const createBlobRes = await createBlob(
      { mimeType: file.type, accessLevel: 'public', module: 'pruwallet' },
      dispatch,
    );
    await fileUpload(createBlobRes.url, file, onProgress);
    return createBlobRes;
  } catch (err) {
    throw new Error(`File upload failed: ${err instanceof Error ? err.message : String(err)}`);
  }
};
